import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get customer
export const getCustomer = createAsyncThunk("customer/getCustomer", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getCustomer({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all customer
export const getAllCustomer = createAsyncThunk("customer/getAllCustomer", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllCustomer();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("customer/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("customer/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("customer/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageCustomer({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getCustomerById = createAsyncThunk("customer/getCustomerById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getCustomerById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create customer
export const createCustomer = createAsyncThunk("customer/createCustomer", async (createData, { rejectWithValue }) => {
  const {
    customerMasterContactDetails,
    billToDetailsCustomerMaster,
    shipToDetails,
    areaDetails,
    customerMasterDocuments,
  } = createData;

  try {
    const body = new FormData();
    Object.entries(createData).forEach(([key, value]) => {
      if (
        key !== "customerMasterContactDetails" &&
        key !== "billToDetailsCustomerMaster" &&
        key !== "shipToDetails" &&
        key !== "customerMasterDocuments" &&
        key !== "areaDetails"
      ) {
        body.append(key, value);
      }
    });
    customerMasterContactDetails?.length > 0 &&
      customerMasterContactDetails.forEach((detail, i) => {
        body.append(`customerMasterContactDetails[${i}][name]`, detail.name);
        body.append(`customerMasterContactDetails[${i}][designation]`, detail.designation);
        body.append(`customerMasterContactDetails[${i}][address]`, detail.address);
        body.append(`customerMasterContactDetails[${i}][email]`, detail.email);
        body.append(`customerMasterContactDetails[${i}][citizenshipNumber]`, detail.citizenshipNumber);
        body.append(`customerMasterContactDetails[${i}][mobileNumber1]`, detail.mobileNumber1);
        body.append(`customerMasterContactDetails[${i}][mobileNumber2]`, detail.mobileNumber2);
        body.append(`customerMasterContactDetails[${i}][telephoneNumber1]`, detail.telephoneNumber1);
        body.append(`customerMasterContactDetails[${i}][telephoneNumber2]`, detail.telephoneNumber2);
      });
    billToDetailsCustomerMaster?.length > 0 &&
      billToDetailsCustomerMaster.forEach((detail, i) => {
        body.append(`billToDetailsCustomerMaster[${i}][addressId]`, detail.addressId);
        body.append(`billToDetailsCustomerMaster[${i}][fullAddress]`, detail.fullAddress);
        body.append(`billToDetailsCustomerMaster[${i}][province]`, detail.province);
        body.append(`billToDetailsCustomerMaster[${i}][district]`, detail.district);
        body.append(`billToDetailsCustomerMaster[${i}][palika]`, detail.palika);
        body.append(`billToDetailsCustomerMaster[${i}][wardNumber]`, detail.wardNumber);
        body.append(`billToDetailsCustomerMaster[${i}][tole]`, detail.tole);
      });
    shipToDetails?.length > 0 &&
      shipToDetails.forEach((detail, i) => {
        body.append(`shipToDetails[${i}][addressId]`, detail.addressId);
        body.append(`shipToDetails[${i}][fullAddress]`, detail.fullAddress);
        body.append(`shipToDetails[${i}][province]`, detail.province);
        body.append(`shipToDetails[${i}][district]`, detail.district);
        body.append(`shipToDetails[${i}][palika]`, detail.palika);
        body.append(`shipToDetails[${i}][wardNumber]`, detail.wardNumber);
        body.append(`shipToDetails[${i}][tole]`, detail.tole);
      });
    customerMasterDocuments?.length > 0 &&
      customerMasterDocuments.forEach((detail, i) => {
        body.append(`customerMasterDocuments[${i}][documentType]`, detail.documentType);
        body.append(`customerMasterDocuments[${i}][document]`, detail.document);
      });

    areaDetails?.length > 0 &&
      areaDetails.forEach((detail, i) => {
        body.append(`areaDetails[${i}][province]`, detail.province);
        body.append(`areaDetails[${i}][district]`, detail.district);
        body.append(`areaDetails[${i}][palika]`, detail.palika);
        body.append(`areaDetails[${i}][wardNumber]`, detail.wardNumber);
        body.append(`areaDetails[${i}][tole]`, detail.tole);
      });

    const { data } = await API.createCustomer(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

export const updateCustomer = createAsyncThunk("customer/updateCustomer", async (updateData, { rejectWithValue }) => {
  const { id, values } = updateData;

  const {
    customerMasterContactDetails,
    billToDetailsCustomerMaster,
    shipToDetails,
    areaDetails,
    customerMasterDocuments,
  } = values;

  try {
    const body = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      if (
        key !== "customerMasterContactDetails" &&
        key !== "billToDetailsCustomerMaster" &&
        key !== "shipToDetails" &&
        key !== "customerMasterDocuments" &&
        key !== "areaDetails"
      ) {
        body.append(key, value);
      }
    });

    customerMasterContactDetails?.length > 0 &&
      customerMasterContactDetails.forEach((detail, i) => {
        if (detail.id) body.append(`customerMasterContactDetails[${i}][id]`, detail.id);
        body.append(`customerMasterContactDetails[${i}][name]`, detail.name);
        body.append(`customerMasterContactDetails[${i}][designation]`, detail.designation);
        body.append(`customerMasterContactDetails[${i}][address]`, detail.address);
        body.append(`customerMasterContactDetails[${i}][email]`, detail.email);
        body.append(`customerMasterContactDetails[${i}][citizenshipNumber]`, detail.citizenshipNumber);
        body.append(`customerMasterContactDetails[${i}][mobileNumber1]`, detail.mobileNumber1);
        body.append(`customerMasterContactDetails[${i}][mobileNumber2]`, detail.mobileNumber2);
        body.append(`customerMasterContactDetails[${i}][telephoneNumber1]`, detail.telephoneNumber1);
        body.append(`customerMasterContactDetails[${i}][telephoneNumber2]`, detail.telephoneNumber2);
      });
    billToDetailsCustomerMaster?.length > 0 &&
      billToDetailsCustomerMaster.forEach((detail, i) => {
        if (detail.id) body.append(`billToDetailsCustomerMaster[${i}][id]`, detail.id);
        body.append(`billToDetailsCustomerMaster[${i}][addressId]`, detail.addressId);
        body.append(`billToDetailsCustomerMaster[${i}][fullAddress]`, detail.fullAddress);
        body.append(`billToDetailsCustomerMaster[${i}][province]`, detail.province);
        body.append(`billToDetailsCustomerMaster[${i}][district]`, detail.district);
        body.append(`billToDetailsCustomerMaster[${i}][palika]`, detail.palika);
        body.append(`billToDetailsCustomerMaster[${i}][wardNumber]`, detail.wardNumber);
        body.append(`billToDetailsCustomerMaster[${i}][tole]`, detail.tole);
      });
    shipToDetails?.length > 0 &&
      shipToDetails.forEach((detail, i) => {
        if (detail.id) body.append(`shipToDetails[${i}][id]`, detail.id);
        body.append(`shipToDetails[${i}][addressId]`, detail.addressId);
        body.append(`shipToDetails[${i}][fullAddress]`, detail.fullAddress);
        body.append(`shipToDetails[${i}][province]`, detail.province);
        body.append(`shipToDetails[${i}][district]`, detail.district);
        body.append(`shipToDetails[${i}][palika]`, detail.palika);
        body.append(`shipToDetails[${i}][wardNumber]`, detail.wardNumber);
        body.append(`shipToDetails[${i}][tole]`, detail.tole);
      });
    customerMasterDocuments?.length > 0 &&
      customerMasterDocuments.forEach((detail, i) => {
        if (detail.id) body.append(`customerMasterDocuments[${i}][id]`, detail.id);
        body.append(`customerMasterDocuments[${i}][documentType]`, detail.documentType);
        body.append(`customerMasterDocuments[${i}][document]`, detail.document);
      });
    areaDetails?.length > 0 &&
      areaDetails.forEach((detail, i) => {
        if (detail.id) body.append(`areaDetails[${i}][id]`, detail.id);
        body.append(`areaDetails[${i}][province]`, detail.province);
        body.append(`areaDetails[${i}][district]`, detail.district);
        body.append(`areaDetails[${i}][palika]`, detail.palika);
        body.append(`areaDetails[${i}][wardNumber]`, detail.wardNumber);
        body.append(`areaDetails[${i}][tole]`, detail.tole);
      });
    const { data } = await API.updateCustomer(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("customer/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
